import { render, staticRenderFns } from "./Contact3.vue?vue&type=template&id=bd36766a&"
import script from "./Contact3.vue?vue&type=script&lang=js&"
export * from "./Contact3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports